import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ServiceDeskFeedbackSettingsEntrypointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const serviceDeskFeedbackSettingsEntrypoint: EntryPoint<
	ServiceDeskFeedbackSettingsEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<ServiceDeskFeedbackSettingsEntrypointComponent>(
		/* webpackChunkName: "async-servicedesk-feedback-settings-entrypoint" */ './ServiceDeskFeedbackSettingsPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({
		queries: {},
		extraProps: {},
	}),
});
